import Vue from 'vue';
import Vuex from 'vuex';

import addresses from './modules/addresses';
import auth from './modules/auth';
import billboard from './modules/billboard';
import cart from './modules/cart';
import checkout from './modules/checkout';
import dispatchPortal from './modules/dispatchPortal';
import orders from './modules/orders';
import pendingOrders from './modules/pendingOrders';
import products from './modules/products';
import profile from './modules/profile';
import utils from './modules/utils';
import navbar from './modules/navbar';
import search from './modules/search';
import contact from './modules/contact';
import driverApplication from './modules/driverApplication'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    addresses,
    auth,
    billboard,
    cart,
    checkout,
    dispatchPortal,
    orders,
    pendingOrders,
    products,
    profile,
    utils,
    navbar,
    search,
    contact,
    driverApplication,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js